import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useFormElement } from '../../composables/useFormElement';
import { makeUseFormElementEmits, makeUseFormElementProps } from '../../composables/useFormElementInterfaces';
import { FieldModel } from '../../interfaces';
import { useBaseFieldValues } from '../../composables/useBaseFieldValues';
import { useTextFormFieldMethods } from '../../composables/useTextFormFieldMethods';
import InputGroupWrapper from '../common/InputGroupWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TextFormField',
  props: makeUseFormElementProps<FieldModel, string>(),
  emits: makeUseFormElementEmits<string>(),
  setup(__props, { emit }) {

const props = __props;





const formElement = useFormElement<FieldModel, string>({
  emit,
  props,
});

const {
  maxLength,
  inputName,
  fieldType,
  readonly,
  inputMode,
  autocomplete,
  placeholder,
  inputClass,
  inputErrorClass,
  fieldErrorsShown,
  valueToInputFn,
  emptyValue,
  number,
} = useBaseFieldValues(formElement);

const { onBlur, onKeyPress, onPaste, setValue } = useTextFormFieldMethods(formElement);

const { model, field } = formElement;

const stringVal = computed(() => {
  const val = valueToInputFn.value(field.value.$model);

  if (number.value && typeof val === 'number') {
    return Number.isNaN(val) ? emptyValue.value : val.toString();
  }

  return val;
});

return { __sfc: true,props, emit, formElement, maxLength, inputName, fieldType, readonly, inputMode, autocomplete, placeholder, inputClass, inputErrorClass, fieldErrorsShown, valueToInputFn, emptyValue, number, onBlur, onKeyPress, onPaste, setValue, model, field, stringVal, InputGroupWrapper }
}

})